var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{}},[_c('Header',{attrs:{"onSelectCallBack":_vm.callbackSectionSelector}}),(_vm.selectedSection=='detail')?_c('Detail',{attrs:{"row":_vm.row}}):_c('span',[_vm._v("Not Applicable")]),_c('span')],1)}
var staticRenderFns = []

export { render, staticRenderFns }